/**
 * Mirror of backend `App\Enums\Common\StatusType` (int-backed enum).
 * Source of truth: backend/app/Enums/Common/StatusType.php
 *
 * Keep cases in sync with the backend — these integers are returned verbatim
 * on `users.attributes.status` and shared by other entities (club-memberships,
 * order-boxes, etc.) that use the same enum.
 */
export const USER_STATUS = Object.freeze({
  PENDING: 1,
  ACTIVE: 2,
  INACTIVE: 3,
  SUSPENDED: 4,
  DECLINED: 5,
});

const STATUS_MAP = {
  [USER_STATUS.PENDING]: { key: 'profile.status.pending', color: 'orange' },
  [USER_STATUS.ACTIVE]: { key: 'profile.status.active', color: 'green' },
  [USER_STATUS.INACTIVE]: { key: 'profile.status.inactive', color: 'gray' },
  [USER_STATUS.SUSPENDED]: { key: 'profile.status.suspended', color: 'red' },
  [USER_STATUS.DECLINED]: { key: 'profile.status.declined', color: 'red' },
};

/**
 * Map a numeric StatusType value → `{ key, color }` for an F7 chip/badge.
 * Returns `null` for missing/unknown values so the caller can hide the chip.
 */
export function mapUserStatus(value) {
  return STATUS_MAP[value] ?? null;
}
